import React from "react";
import github from "../../../Icon/github.png";
import "./Footer.css";

const Footer = () => {
  return (
    <div className ='footer-section'>
      <div className=" footer-icon d-flex justify-content-center">
        <a href="https://github.com/sunnysakib" target="_blank">
          <img className="" src={github} alt="" />
        </a>
      </div>
      <p className="text-center mt-2">
          Designed by Hayat & Akbar Jamshed
          <br /> Customized & Built by Sunny
      </p>
    </div>
  );
};

export default Footer;
